/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, count: NonNullable<unknown> }} Stocktake_Snapshot_Batch_SummaryInputs */

const vi_stocktake_snapshot_batch_summary = /** @type {(inputs: Stocktake_Snapshot_Batch_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} — ${i?.count} lô`)
};

/**

* @param {Stocktake_Snapshot_Batch_SummaryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_snapshot_batch_summary = /** @type {((inputs: Stocktake_Snapshot_Batch_SummaryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Snapshot_Batch_SummaryInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_snapshot_batch_summary(inputs)
});